import { Namespaces } from 'redux/namespaces'

export const RuntimeTypes = {
    SET_WINDOW_HEIGHT: `${Namespaces.RUNTIME}_SET_WINDOW_HEIGHT`,
    SET_WINDOW_WIDTH: `${Namespaces.RUNTIME}_SET_WINDOW_WIDTH`,
    SET_KEYBOARD_VISIBLE: `${Namespaces.RUNTIME}_SET_KEYBOARD_VISIBLE`,
    SET_VERSION_CHECK: `${Namespaces.RUNTIME}_SET_VERSION_CHECK`,
    SET_SCREEN_ANIMATING: `${Namespaces.RUNTIME}_SET_SCREEN_ANIMATING`,
    SET_ONLINE: `${Namespaces.RUNTIME}_SET_ONLINE`,
}